(() => {
  // assets/scripts/journal.ts
  class JournalFilter extends HTMLElement {
    connectedCallback() {
      const buttons = Array.from(this.querySelectorAll(".journal__filter"));
      const posts = Array.from(this.querySelectorAll(".journal__post"));
      for (const button of buttons) {
        button.addEventListener("click", () => {
          const filter = button.dataset.filter ?? "all";
          for (const other of buttons) {
            const isActive = other === button;
            other.classList.toggle("is-active", isActive);
            other.setAttribute("aria-pressed", String(isActive));
          }
          for (const post of posts) {
            const tags = (post.dataset.cat ?? "").split(" ").filter(Boolean);
            post.hidden = !(filter === "all" || tags.includes(filter));
          }
        });
      }
    }
  }
  if (!customElements.get("journal-filter")) {
    customElements.define("journal-filter", JournalFilter);
  }
})();
